import { render, staticRenderFns } from "./FormAddSO.vue?vue&type=template&id=ae622c96"
import script from "./FormAddSO.vue?vue&type=script&lang=js"
export * from "./FormAddSO.vue?vue&type=script&lang=js"
import style0 from "./FormAddSO.vue?vue&type=style&index=0&id=ae622c96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports